export default [
  {
    path: '/verify-email',
    name: 'VerifyEmail',
    component: () => import('@/views/common/VerifyEmail.vue'),
  },
];
